<form class="edit-form" *ngIf="!isLoading" [formGroup]="editForm" (submit)="onSubmit()">

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.name.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="name">
    <mat-error>{{ 'repository.addresses.edit.name.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.street.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="street">
    <mat-error>{{ 'repository.addresses.edit.street.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.streetNumber.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="streetNumber">
    <mat-error>{{ 'repository.addresses.edit.streetNumber.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.locality.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="locality">
    <mat-error>{{ 'repository.addresses.edit.locality.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.postalCode.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="postalCode">
    <mat-error>{{ 'repository.addresses.edit.postalCode.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'repository.addresses.edit.phone.label' | translate }}</mat-label>
    <input type="text" matInput formControlName="phone">
    <mat-error>{{ 'repository.addresses.edit.phone.errorMessage' | translate }}</mat-error>
  </mat-form-field>

  <fieldset class="sites-list">
    <legend>
      <h3>{{ 'users.edit.sites.title' | translate }}</h3>
    </legend>
    <mat-list formArrayName="sites">
      <mat-list-item *ngFor="let siteControl of getArray('sites').controls; index as i">
        <section class="form-field">
          <app-autocomplete [control]="siteControl" [list]="selectableSites" (changeEvent)="generateSelectableSites()"
            label="users.edit.sites.select.label" errorMsg="users.edit.sites.select.errorMessage">
          </app-autocomplete>
        </section>

        <button type="button" mat-icon-button color="primary" [disabled]="getArray('sites').controls.length <= 1"
          (click)="onRemoveSite(i)">
          <mat-icon aria-label="delete">delete</mat-icon>
        </button>
      </mat-list-item>
      <mat-list-item>
        <button type="button" mat-icon-button color="primary" (click)="onAddSite()">
          <mat-icon aria-label="Add">add</mat-icon>
        </button>
      </mat-list-item>
    </mat-list>
  </fieldset>

  <section class="tagCheckboxContainer">
    <mat-form-field class="tag-field">
      <mat-chip-grid #chipList aria-label="Puce selection" formControlName="tags">
        <mat-chip-row *ngFor="let tag of tags.value" [selectable]="selectable" [removable]="removable"
          (removed)="removeTag(tag)">
          {{tag}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-row>
        <input placeholder="Puce(s) NFC" [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="addTag($event)">
      </mat-chip-grid>
    </mat-form-field>
    <div class="checkboxContainer">
      <mat-checkbox formControlName="isSender">Lieu d'enlèvement</mat-checkbox>
      <mat-checkbox formControlName="isReceiver">Destinataire</mat-checkbox>
    </div>
  </section>

  <app-validate-and-cancel (submitEvent)="endForm($event)" [editForm]="editForm"
    [disabling]="editForm.invalid || (!editForm.value.isSender && !editForm.value.isReceiver)"></app-validate-and-cancel>

</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>